import React from 'react'
import './header.css'

export default function Header() {
  return (
    <div className="headerContainer sm-headerContainer">
      <img id="icon" src={require('../../Assets/images/dove.png')} alt="Logo" />
    </div>
  )
}
